import React from 'react'
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Link, Button, Divider } from '@mui/material';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';

const theme = createTheme({
    palette: {
        primary: {
            main: "#99aab5", // custom primary color
        },
        secondary: {
            main: "#F27920", // custom secondary color
        },
    },
});

export default function CashDonation() {
    return (
        <div className="bg-white p-20 ">
            <div><div className='pb-5'><h1 className='text-2xl font-bold text-[#F27920]'>Cash Donation</h1></div></div>
            <Divider className='' />
            <div className='lg:flex gap-10'>

                <div className='lg:w-1/2 my-5'>
                    <ThemeProvider theme={theme}>
                        <Button color="secondary" variant="contained" fullWidth>
                            <Link target='_blank' rel='noopener noreferrer' href='https://savetheseaturtle.org/Support/CashDonation.html' style={{ color: '#ffffff' }}>

                                <div className='text-center'>
                                    <div className='text-center'><VolunteerActivismIcon fontSize='large' /></div>

                                    <div className='text-center pt-5'>Cash Donation</div>
                                </div>


                            </Link>
                        </Button>
                    </ThemeProvider>                </div>
                <div className='lg:w-1/2 my-5'>
                    <ThemeProvider theme={theme}>
                        <Button color="secondary" variant="contained" fullWidth><Link target='_blank' rel='noopener noreferrer' href='https://savetheseaturtle.org/Support/FriendCashDonation.html' style={{ color: '#ffffff' }}>

                            <div className='text-center'>
                                <div className='text-center'><VolunteerActivismIcon fontSize='large' /></div>

                                <div className='text-center pt-5'>Cash Donation for a Friend</div>
                            </div>


                        </Link>
                        </Button>
                    </ThemeProvider>
                </div>

            </div>

        </div >
    )
}
